<template>
  <div>
    <Header />

    <div class="container">
      <div class="text-center p-3">
        <h2 class="welcome-text" v-if="firstName && firstName.length > 1">Welcome, {{firstName}} {{lastName}}</h2>
        <h3 class="current-pts" v-if="current_reward_points > 0">You Have <br /> {{current_reward_points}} Pts</h3>

        <router-link :to="{ path: '/rewards'}">
          <button class="btn-view-free-rewards">View Free Rewards</button>
        </router-link>
      </div>

      <div class="row">
        <div class="col-md-4 text-center mt-4">
          <div class="home-menu">
            <div class="menu-logo">
              <img :src='"@/assets/images/noah_logo.svg"' alt="Noah's" />
            </div>
            <button class="btn-view-menu" v-on:click="open_shop_page(1)">View Menu</button>
          </div>
        </div>
        <div class="col-md-4 text-center mt-4">
          <div class="home-menu">
            <div class="menu-logo">
              <img :src='"@/assets/images/froot_logo.svg"' class="menu-logo" alt="Froot" />
            </div>
            <button class="btn-view-menu" v-on:click="open_shop_page(2)">View Menu</button>
          </div>
        </div>
        <div class="col-md-4 text-center mt-4">
          <div class="home-menu">
            <div class="menu-logo">
              <img :src='"@/assets/images/sparkiez_logo.svg"' class="menu-logo" alt="Sparkiez" />
            </div>
            <button class="btn-view-menu" v-on:click="open_shop_page(3)">View Menu</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import Header from "@/components/header";
import {signOut} from "@/utils/auth";

export default {
  components: {
    Header,
  },
  computed: {
    ...mapGetters({
      signedIn: 'auth/signedIn',
      firstName: 'auth/getFirstName',
      lastName: 'auth/getLastName',
      webUserAuthed: 'auth/webUserAuthed',
      cartid_is_ready: 'cart/cartid_is_ready',
      getAccessToken: 'auth/getAccessToken',
      pages_products_loaded: 'cart/pages_products_loaded',
      current_reward_points: 'cart/current_reward_points',
    })
  },
  data() {
    return {

    }
  },
  mounted() {
    this.getCartId();
    if(!this.signedIn) {
      signOut();
      this.$router.push({name: "login", 'params':{} });
    }
  },
  watch: {
    cartid_is_ready: async function() {

      if(this.webUserAuthed) {
        this.$store.dispatch('auth/getAccount', {register_it: 0})
        this.$store.dispatch('cart/loadPagesProducts');
        this.$store.dispatch('cart/loadShoppingCart');
      }

    },
    pages_products_loaded: function () {
        // this.openShopPage();
    },
  },
  methods: {
    open_shop_page(page_group) {
      this.$router.push({name: "shop", 'params':{page_group: page_group} });
    },
    getCartId() {
      let browserstring = "";
      let cartid        = localStorage.getItem('cartid'); // is empty on new accounts
      this.$store.dispatch('cart/checkCartId', {cartid, browserstring});
    },
  }
}

</script>

<style scoped>
@font-face {
  font-family: "Neue";
  src: local("Neue"),
  url('../assets/fonts/neue-haas-grotesk/NeueHaasDisplayBoldItalic.ttf') format("truetype");
}
.home-login{
  font-size: 18px;
  color: black;
  font-weight: 900;
}
.home-register{
  font-size: 18px;
  font-weight: 900;
  color: white;
  border: 0;
  padding: 10px 16px;
  background-color: #19911A;
  border-radius: 30px;
  text-align: center;
}
.center {
  margin: auto;
  width: 100%;
  padding: 10px;
}
.home-hero{
  background-color: #19911A;
  padding: 20px 10px;
  font-family: "Neue";
}
.home-hero h3{
  font-size: 32px;
  color: white;
  line-height: 1.4;
  font-style: italic;
}
.home-hero h4{
  font-size: 24px;
  font-weight: 900;
  color: white;
  line-height: 1.2;
}
.home-select{
  padding: 50px 0;
  font-family: "Neue";
}
.home-select p{
  font-size: 32px;
  color: black;
}
</style>


